import { render, staticRenderFns } from "./BeforeDetailRelatedModules.vue?vue&type=template&id=38b693a2&scoped=true"
import script from "./BeforeDetailRelatedModules.vue?vue&type=script&lang=js"
export * from "./BeforeDetailRelatedModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b693a2",
  null
  
)

export default component.exports